import React from 'react';
import GenreReportTemplate from './GenreReportTemplate';
import { fetchProgramsByCategoryKeywords } from '../reportsApi';
import type { ReportComponentProps } from '../reportDefinitions';

const AnthologyProgramsReport: React.FC<ReportComponentProps> = () => {
  return (
    <GenreReportTemplate
      reportId="anthology-programs"
      defaultKeywords={['antholog']}
      fetcher={(keywords) =>
        fetchProgramsByCategoryKeywords(keywords, {
          reportId: 'anthology-programs',
          includeProgramMetadata: true
        })
      }
      title="Programs supporting anthologies"
      subtitle="Programs surfaced via categories that reference anthologies, collections, or compilation opportunities."
      emptyMessage="No anthology-aligned programs were detected. Refresh the report or adjust the filters at the source."
      emphasisNote="Matched by category naming that contains ‘antholog’; program titles and organizations are checked for the same keywords."
      noteLabel="anthology"
    />
  );
};

export default AnthologyProgramsReport;
